import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import DateRangeFilter from '../../components/searchBar/DateRangeFilter';
import SelectFilter from '../../components/searchBar/SelectFilter';
import {
  DEFAULT_REPORT_DOWNLOAD_STATE,
} from "../../constants/constants";
import * as types from '../../constants/actionTypes';
import UserLevelFilter from "../../components/searchBar/UserLevelFilter";
import { makeStyles } from "@mui/styles";
import theme from '../../constants/theme';


const useStyles = makeStyles(() => ({
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    fontStyle: "italic",
  },
}));

const ReportDownloadFilter = () => {
  const classes = useStyles();
  const { filters, levelId, showAll, userAndLevelName, reportDownloadState } = useSelector((state) => state.report);
  const dispatch = useDispatch();
  const setFilters = (filters) => dispatch({ type: types.SET_FILTERS, filters });
  const setReportDownloadState = (val) => dispatch({ type: types.SET_REPORT_DOWNLOAD_STATE, value: val });
  const setUserAndLevelName = (val) => dispatch({ type: types.SET_USER_AND_LEVEL_NAME, value: val });
  const setLevelId = (val) => dispatch({ type: types.SET_LEVEL_ID, value: val });
  const setShowAll = (val) => dispatch({ type: types.SET_SHOW_ALL, value: val });

  useEffect(() => {
    const {
      fromDate,
      toDate,
      reportType,
    } = reportDownloadState;

    setFilters({
      fromDate,
      toDate,
      reportType,
      levelId,
      showAll,
    });
  }, [reportDownloadState, levelId, showAll]);

  return (
    <>
      <DateRangeFilter
        selectedFromDate={reportDownloadState.fromDate}
        setSelectedFromDate={(val) => setReportDownloadState({ ...reportDownloadState, fromDate: val })}
        selectedToDate={reportDownloadState.toDate}
        setSelectedToDate={(val) => setReportDownloadState({ ...reportDownloadState, toDate: val })}
      />

      <UserLevelFilter
        levelId={levelId}
        setLevelId={setLevelId}
        showAll={showAll}
        setShowAll={setShowAll}
        userAndLevelName={userAndLevelName}
        setUserAndLevelName={setUserAndLevelName}
      />

      <SelectFilter
        size="small"
        select
        variant="outlined"
        label="Report Type"
        InputLabelProps={{
          shrink: true,
        }}
        SelectProps={{
          value: reportDownloadState.reportType || "deposit_withdraw",
          onChange: (e) =>
            setReportDownloadState({ ...reportDownloadState, reportType: e.target.value }),
        }}
      >
        <MenuItem value="deposit_withdraw">Deposit/Withdraw Report</MenuItem>
        <MenuItem value="cc_transaction">CC Transaction Report</MenuItem>
        <MenuItem value="cc_detail">CC Detail Report</MenuItem>
      </SelectFilter>
    </>
  );
};

export default ReportDownloadFilter;
